import { AlignmentType } from 'docx'
import {
  createEmptyLine,
  createParagraph,
  createSeparateParagraphs,
} from './docxFunctions'
import {
  BOLD_TEXT,
  DEFAULT_TEXT,
  createCombinationParagraph,
} from './docxFunctions'
import {
  formatCrItemPresentation,
  normalizeCrPresence,
} from '@/components/expSummary/summaryCrPresence/crPresenceConst'
import { withPresentationFont } from './presentationDocxStyle'

const RUN = withPresentationFont()

/** Развёрнутый блок «Наличие в КР» для docx (тезисы, комментарии). */
export function createCrPresenceDocxBlocks(crPresence, legacyCrNames = '') {
  const state = normalizeCrPresence(crPresence, legacyCrNames)
  const blocks = []

  blocks.push(
    createCombinationParagraph([
      { type: BOLD_TEXT, content: 'Наличие ЛП в клинических рекомендациях: ' },
      {
        type: DEFAULT_TEXT,
        content: state.hasInCr ? 'да.' : 'нет в утв. КР.',
      },
    ])
  )

  if (!state.items.length) {
    const legacy = String(legacyCrNames || '').trim()
    if (legacy && !state.hasInCr) {
      blocks.push(...createSeparateParagraphs(legacy, { alignment: AlignmentType.JUSTIFIED }, RUN))
    }
    blocks.push(createEmptyLine())
    return blocks
  }

  state.items.forEach((item, idx) => {
    if (idx > 0) blocks.push(createEmptyLine())
    formatCrItemPresentation(item)
      .split('\n')
      .forEach(line => {
        if (!String(line).trim()) return
        blocks.push(
          createParagraph(line, { alignment: AlignmentType.JUSTIFIED }, RUN)
        )
      })
  })

  blocks.push(createEmptyLine())
  return blocks
}
